import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './Updates.module.css';

export default function Updates() {
  const navigate = useNavigate();
  const [updates, setUpdates] = useState([]);
  const [laden, setLaden]     = useState(true);

  useEffect(() => {
    axios.get('/api/platform-updates/alle')
      .then(res => setUpdates(res.data.updates || []))
      .catch(() => {})
      .finally(() => setLaden(false));
  }, []);

  return (
    <div className={styles.pagina}>
      <div className={styles.header}>
        <h1 className={styles.titel}>Platform updates</h1>
        <p className={styles.subtitel}>Overzicht van alle versies en wijzigingen</p>
      </div>

      {laden ? (
        <div className={styles.laden}>Laden...</div>
      ) : updates.length === 0 ? (
        <div className={styles.leeg}>Geen updates beschikbaar.</div>
      ) : (
        <div className={styles.lijst}>
          {updates.map(update => (
            <div key={update.id} className={styles.kaart}>
              <div className={styles.kaartHeader}>
                <span className={styles.versie}>{update.versie}</span>
                <span className={styles.datum}>
                  {new Date(update.datum).toLocaleDateString('nl-NL', { day:'numeric', month:'long', year:'numeric' })}
                </span>
              </div>
              <h2 className={styles.kaartTitel}>{update.titel}</h2>
              <p className={styles.kaartOmschrijving}>{update.omschrijving}</p>
            </div>
          ))}
        </div>
      )}
      {/* Footer */}
      <div className={styles.footer}>
        <button className={styles.terugKnop} onClick={() => navigate('/dashboard')}>
          ← Terug naar dashboard
        </button>
      </div>
    </div>
  );
}
